module.exports = __webpack_public_path__ + "img/acc6.19e3f2d2.png";